<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-form inline :model="queryParams">
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.articleType" placeholder="文章分类" clearable>
              <el-option v-for="(item, index) in articleType" :key="index" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-select v-model="queryParams.status" placeholder="状态" clearable>
              <el-option label="未发布" value="0" />
              <el-option label="已发布" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">新增文章</el-button>
          </el-form-item>
        </el-form>
      </template>

      <el-table v-sticky-header fit highlight-current-row border :data="list" header-cell-class-name="table-header-cell style1">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell style1">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文章分类" prop="articleType" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="row.articleType | articleTypeTag">{{ row.articleType | articleTypeName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布日期" prop="publishDate" width="140" align="center" />
        <el-table-column label="文章标题" prop="title" min-width="150" class-name="name-col" />
        <el-table-column label="文章摘要" prop="summary" min-width="150" class-name="name-col" />
        <el-table-column label="状态" prop="status" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>
        </el-table-column>

        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleEdit(row)"><i class="el-icon-edit" /> 编辑文章</el-dropdown-item>
                <el-dropdown-item divided @click.native="handleRemove(row)"><i class="el-icon-delete" /> 删除文章</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="loadData" />
    </el-card>
  </div>
</template>

<script>
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getArticlePages, updateArticleDetail, deleteArticleDetail } from '@/api/article'

const ARTICLETYPE = [
        { id: 11, name: '首页公告', type: '' },
        { id: 12, name: '优品商城公告', type: '' },
        { id: 13, name: '福利商城公告', type: '' },
        { id: 14, name: '本地商家公告', type: '' },
        { id: 2, name: '新人手册', type: 'warning' },
        { id: 3, name: '资讯', type: 'info' },
        { id: 5, name: '用户协议', type: 'danger' },
        { id: 6, name: '隐私政策', type: 'danger' },
        { id: 7, name: '退货政策', type: 'danger' }
      ]

export default {
  name: 'ArticleIndex',
  components: {
    Pagination: () => import('@/components/Pagination')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  filters: {
    articleTypeTag(id) {
      const index = ARTICLETYPE.findIndex(item => item.id === id)
      return ARTICLETYPE[index].type
    },
    articleTypeName(id) {
      const index = ARTICLETYPE.findIndex(item => item.id === id)
      return ARTICLETYPE[index].name
    }
  },
  data() {
    this.articleType = ARTICLETYPE
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        page: 1,
        limit: 20,
        status: undefined,
        articleType: undefined
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getArticlePages(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
        setTimeout(() => {
          this.loading = false
        }, 500)
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.loadData()
    },
    handleCreate() {
      this.$router.push({ path: '/article/edit', query: { from: 'list' }})
    },
    handleEdit(item) {
      this.$router.push({ path: `/article/edit`, query: { from: 'list', articleId: `${item.id}` }})
    },
    handleRemove(item) {
      this.$confirm(`确定要删除该文章吗？`, '删除提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteArticleDetail(item.id).then(response => {
          if (response) {
            const index = this.list.findIndex(aa => aa.id === item.id)
            if (index >= 0) {
              this.list.splice(index, 1)
              this.total--
            }
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          setTimeout(() => { this.loading = false }, 500)
        })
      })
    },
    handleUpdate(item) {
      updateArticleDetail(item).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
